/** HUD / menu SVG icons. */
export const vt = e => `<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${e}</svg>`;
export const yt = {
        play: vt(`<path d="M7 4v16l13-8z" fill="currentColor" stroke="none"/>`),
        pause: vt(`<path d="M8 5v14"/><path d="M16 5v14"/>`),
        up: vt(`<path d="m6 13 6-6 6 6"/><path d="m6 19 6-6 6 6" opacity=".45"/>`),
        close: vt(`<path d="M18 6 6 18"/><path d="m6 6 12 12"/>`),
        camera: vt(`<path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>`),
        headphones: vt(`<path d="M4 15v-3a8 8 0 0 1 16 0v3"/><rect x="3" y="14" width="4" height="6" rx="1.5"/><rect x="17" y="14" width="4" height="6" rx="1.5"/>`),
        share: vt(`<path d="M12 3v13"/><path d="m7 8 5-5 5 5"/><path d="M5 14v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5"/>`),
        download: vt(`<path d="M12 3v13"/><path d="m7 11 5 5 5-5"/><path d="M5 21h14"/>`),
        menu: vt(`<path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/>`),
        person: vt(`<circle cx="12" cy="8" r="3.5"/><path d="M5 20c1.5-4 4-6 7-6s5.5 2 7 6"/>`),
        back: vt(`<path d="M15 6 9 12l6 6"/>`)
    };
